import React, { useState, useEffect } from 'react';
import { RefreshCw } from 'lucide-react';

const ReloadPrompt = ({ onReload }) => {
  const [showPrompt, setShowPrompt] = useState(false);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setShowPrompt(true);
    }, 5 * 60 * 1000); // 5 minutes in milliseconds

    return () => clearInterval(intervalId);
  }, []);

  const handleReload = () => {
    onReload();
    setShowPrompt(false);
  };

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white border border-blue-200 rounded-lg shadow-lg p-4 max-w-sm">
        <div className="flex items-center">
          <RefreshCw className="h-4 w-4 text-blue-500" />
          <div className="flex items-center justify-between flex-1 ml-2">
            <span className="text-sm text-gray-700">New data is available</span>
            <div className="flex gap-2 ml-4">
              <button
                onClick={handleReload}
                className="px-3 py-1 text-sm bg-blue-500 text-white rounded-md hover:bg-blue-600 transition-colors"
              >
                Reload
              </button>
              <button
                onClick={() => setShowPrompt(false)}
                className="px-3 py-1 text-sm text-gray-600 hover:text-gray-800 transition-colors"
              >
                Dismiss
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReloadPrompt;